import { render, staticRenderFns } from "./reviewPraqualifikasiK3L.vue?vue&type=template&id=e3858a84&"
import script from "./reviewPraqualifikasiK3L.vue?vue&type=script&lang=js&"
export * from "./reviewPraqualifikasiK3L.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports